class GoogleMaps {
  map;
  mapElement = null;
  mapLoaded = false;
  styles;
  settings;
  center = { lat: 0, lng: 0 };

  constructor(element, data) {
    console.log(data);
    this.mapElement = element;
    // this.styles = data.styles;
    this.settings = null;
    this.lat = data.lat;
    this.lng = data.lng;
    this.url = data.url;
    this.zoom = data.zoom;
    this.infoContent = data.infoContent;

    this.initMap();
  }

  initMap = () => {
    if (this.mapLoaded) return true;

    if (!this.mapElement) {
      console.error("Pierwszy argument musi być elementem, w którym ma być wyświetlona mapa");
      return true;
    }

    this.mapLoaded = true;

    const map = new google.maps.Map(this.mapElement, {
      center: { lat: parseFloat(this.lat), lng: parseFloat(this.lng) },
      zoom: parseInt(this.zoom),
      disableDefaultUI: true,
    });

    const marker = new google.maps.Marker({
      position: { lat: parseFloat(this.lat), lng: parseFloat(this.lng) },
      map: map,
    });

    var url = `https://www.google.com/maps/search/?api=1&query=${this.lat},${this.lng}`;

    google.maps.event.addListener(marker, "click", function () {
      window.open(url, "_blank");
    });
  };

  addEvents = () => {
    window.addEventListener("resize", this.initMap);
    window.addEventListener("scroll", this.initMap);
  };

  init = () => {
    this.addEvents();
  };
}

export default GoogleMaps;
